"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyBetaUserInvitationRequest = void 0;
const zod_1 = require("zod");
exports.VerifyBetaUserInvitationRequest = zod_1.z.object({
    email: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    phoneNumber: zod_1.z.string(),
});
